(ns ui.view.card.counterparty-diligence-progress.view
  (:require
   [common.localization :as loc]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.components.radix-ui.tooltip.view :as tooltip]
   [ui.util :as uu]
   [ui.view.card.counterparty-diligence-progress.event :as event]
   [ui.view.card.counterparty-diligence-progress.sub :as sub]
   [ui.view.card.shared-components.card-container :as card-container]))

(defn signatory-error-view
  [{:keys [ctx]}]
  (let [signatory-error @(rf/subscribe [::sub/signatory-error ctx])]
    [:div
     (case signatory-error
       :signatory-error/no-signatories (loc/tr :no-signatories-error-label)
       :signatory-error/data-missing (loc/tr :signatory-data-missing-error-label)
       nil)]))

(defn change-status-info-view
  [{:keys [current-status new-status ctx] :as props}]
  (let [signatory-error @(rf/subscribe [::sub/signatory-error ctx])
        e-signature-required? @(rf/subscribe [::sub/e-signature-required? ctx])]
    (case [current-status new-status]
      [:counterparty-diligence-process.status/draft
       :counterparty-diligence-process.status/sent-to-responders]
      [:div
       (loc/tr :counterparty-diligence/change-status-from-draft-to-sent-to-responders-info-text)]

      [:counterparty-diligence-process.status/sent-to-responders
       :counterparty-diligence-process.status/draft]
      [:div
       (loc/tr :counterparty-diligence/change-status-from-sent-to-responders-to-draft-info-text)]

      [:counterparty-diligence-process.status/draft
       :counterparty-diligence-process.status/waiting-for-e-sign]
      (if signatory-error
        [signatory-error-view props]
        [:div
         (loc/tr :counterparty-diligence/change-status-forward-to-esign-info-text)])

      [:counterparty-diligence-process.status/sent-to-responders
       :counterparty-diligence-process.status/waiting-for-e-sign]
      (if signatory-error
        [signatory-error-view props]
        [:div
         (loc/tr :counterparty-diligence/change-status-forward-to-esign-info-text)])

      [:counterparty-diligence-process.status/waiting-for-e-sign
       :counterparty-diligence-process.status/draft]
      [:div
       (loc/tr :counterparty-diligence/change-status-from-esign-to-draft-info-text)]

      [:counterparty-diligence-process.status/waiting-for-e-sign
       :counterparty-diligence-process.status/sent-to-responders]
      [:div
       (loc/tr :counterparty-diligence/change-status-from-esign-to-sent-to-responders-info-text)]

      [:counterparty-diligence-process.status/review
       :counterparty-diligence-process.status/sent-to-responders]
      (if e-signature-required?
        [:div
         (loc/tr :counterparty-diligence/change-status-from-review-to-sent-to-responders-with-esign-info-text)]
        [:div
         (loc/tr :counterparty-diligence/change-status-from-review-to-sent-to-responders-info-text)])

      [:counterparty-diligence-process.status/review
       :counterparty-diligence-process.status/draft]
      (if e-signature-required?
        [:div
         (loc/tr :counterparty-diligence/change-status-from-review-to-draft-with-esign-info-text)]
        [:div
         (loc/tr :counterparty-diligence/change-status-from-review-to-draft-info-text)])

      [:counterparty-diligence-process.status/review
       :counterparty-diligence-process.status/completed]
      [:div
       (loc/tr :counterparty-diligence/complete-process?)]

      [:counterparty-diligence-process.status/draft
       :counterparty-diligence-process.status/completed]
      [:div
       (loc/tr :counterparty-diligence/complete-process?)]

      [:counterparty-diligence-process.status/sent-to-responders
       :counterparty-diligence-process.status/completed]
      [:div
       (loc/tr :counterparty-diligence/complete-process?)]

      [:div])))

(defn status-change-confirmation-modal
  [{:keys [ctx] :as props}]
  (let [open? @(rf/subscribe [::sub/change-status-confirmation-modal-open? ctx])
        current-status @(rf/subscribe [::sub/process-status ctx])
        {new-status       :value
         new-status-label :label} @(rf/subscribe [::sub/change-to-status ctx])
        submitting? @(rf/subscribe [::sub/submitting-status-change? ctx])
        can-submit-status-change? @(rf/subscribe [::sub/can-submit-status-change? ctx])

        submit-disabled? (or submitting?
                             (not can-submit-status-change?))]
    [modal/view
     {:visible? open?}
     [:p (loc/tr :change-status-to- [new-status-label])]
     [change-status-info-view
      (merge props
             {:current-status current-status
              :new-status     new-status})]
     [:<>
      [button/sm-secondary-hollow
       {:on-click #(rf/dispatch [::event/close-change-status-confirmation-modal ctx])}
       (loc/tr :cancel)]
      [button/sm-primary-solid
       {:on-click  #(rf/dispatch [::event/submit-confirm-status-change ctx])
        :disabled? submit-disabled?}
       (if submitting?
         (loc/tr :submitting)
         (loc/tr :confirm))]]]))

(defn change-status-error-modal
  [{:keys [ctx]}]
  (let [open? @(rf/subscribe [::sub/change-status-error-modal-open? ctx])
        error-kw @(rf/subscribe [::sub/change-status-error-kw ctx])]
    [modal/view
     {:visible? open?}
     [:div
      {:class "flex items-center gap-2"}
      [:i {:class "fal fa-exclamation-circle text-danger-regular"}]
      [:p (loc/tr :an-error-occurred)]]
     [:div
      {:class "flex items-center gap-1"}
      (case error-kw
        :starting-esign-process-failed
        [:p (loc/tr :sending-e-signature-request-failed)]
        [:p (loc/tr :an-unknown-error-occurred-while-changing-status)])
      [:p (loc/tr :please-contact-our-support-for-assistance)]]
     [:<>
      [button/sm-secondary-hollow
       {:on-click #(rf/dispatch [::event/close-change-status-error-modal ctx])}
       (loc/tr :close)]]]))

(defn steps-view
  [{:keys [ctx]}]
  (let [steps @(rf/subscribe [::sub/status-steps ctx])]
    [:div
     {:class "relative h-20"}
     [:div
      {:class "relative flex justify-between"}
      (->> steps
           (map-indexed
            (fn [index {:keys [value label step-status disabled? error? tooltip]}]
              (let [first? (zero? index)
                    last? (= (inc index) (count steps))

                    status (if (and last? (= step-status :current))
                             :completed
                             step-status)

                    on-click (fn [_]
                               (when-not disabled?
                                 (rf/dispatch [::event/open-change-status-confirmation-modal ctx value])))

                    circle-component
                    [:div
                     {:class (uu/cm "h-10 w-10 z-10 flex items-center justify-center shrink-0 bg-base-light border rounded-full"
                                    (when-not disabled?
                                      "cursor-pointer")
                                    (case status
                                      :completed (uu/cm "bg-primary-regular"
                                                        (when-not disabled?
                                                          "hover:bg-primary-gloomy"))
                                      :current (uu/cm "border-0 ring ring-2 ring-offset-2 ring-primary-regular bg-primary-regular"
                                                      (when error?
                                                        "bg-danger-regular ring-danger-regular text-danger-regular-text"))
                                      :upcoming (uu/cm "bg-base-light"
                                                       (when-not disabled?
                                                         "hover:bg-base-regular"))
                                      ""))}
                     (cond
                       (= status :completed)
                       [:i {:class "fal fa-check font-medium"}]

                       :else
                       [:span
                        (inc index)])]]
                ^{:key (str "divier" value)}
                [:div
                 {:class    (uu/cm "relative grow flex justify-center select-none")
                  :on-click on-click}
                 (when-not first?
                   [:div
                    {:class (uu/cm "absolute top-1/2 -translate-y-1/2 right-1/2 w-1/2 h-0.5 bg-secondary-light"
                                   (when (some #{status} [:current :completed])
                                     "bg-secondary-regular"))}])
                 (when-not last?
                   [:div
                    {:class (uu/cm "absolute top-1/2 -translate-y-1/2 left-1/2 w-1/2 h-0.5 bg-secondary-light"
                                   (when (= status :completed)
                                     "bg-secondary-regular"))}])

                 [:div
                  {:class "relative z-10"}
                  (if tooltip
                    [tooltip/view
                     {:trigger-class "cursor-default"}
                     circle-component
                     [:span tooltip]]
                    circle-component)]

                 [:div
                  {:class    (uu/cm "absolute w-full top-12 left-1/2 -translate-x-1/2 text-center text-sm m-0 font-medium"
                                    (when-not disabled? "cursor-pointer"))
                   :on-click on-click}
                  label]]))))]]))

(defn view
  [props]
  [card-container/view
   {:class "border-0 bg-transparent"}
   [:div
    {:class "flex flex-col gap-2"}
    [:div
     {:class "flex justify-center"}
     [:p
      {:class "text-sm m-0 font-semibold"}
      (loc/tr :process-status)]]
    [:div
     {:class "w-full max-w-4xl mx-auto"}
     [steps-view props]]]
   [status-change-confirmation-modal props]
   [change-status-error-modal props]])
